<template>
  <div>
    <!-- 列表页面 -->
    <div class="container" v-if="viewStatus == 1">
      <sticky-top>
        <div class="header">
          <div class="title">横幅管理</div>          
          <div class="header-right">
            <el-button type="primary" icon="el-icon-circle-plus-outline" round @click="handleAdd">添加横幅</el-button>
          </div>
        </div>
      </sticky-top>
      <!-- 表格 -->
      <lin-table
        ref="table"
        :tableColumn="tableColumn"
        :tableData="tableData"
        :operate="operate"
        @handleEdit="handleEdit"
        @handleDelete="handleDelete"
        @row-click="rowClick"
        v-loading="loading"></lin-table>
    </div>      

    <!-- 添加页面 -->
    <custom-add v-else-if="viewStatus == 2" @editClose="editClose" :dataID="dataID"></custom-add>
    
    <!-- 编辑页面 -->
    <custom-editor v-else-if="viewStatus == 3" @editClose="editClose" :dataID="dataID"></custom-editor>
  </div>
</template>

<script>
import LinTable from '@/components/base/table/lin-table'
import CustomAdd from './custom/CustomAdd'
import CustomEditor from './custom/CustomEditor'
import customApi from '../models/custom'
import TableImage from '../../Common/components/TableImage'

export default {
  components: {
    LinTable,
    CustomAdd,
    CustomEditor,
  },
  data() {
    return {
      tableColumn: [{ prop: 'title', label: '名称' },
        {
          prop: 'image1',
          label: '图标',
          style: {width:"auto",height:"20px"},
          component: TableImage,
        },
        {
          prop: 'image2',
          label: '选中图标',
          style: {width:"auto",height:"20px"},
          component: TableImage,
        },
        { prop: 'url', label: '链接' },
        { prop: 'summary', label: '简介' },
      ],
      tableData: [],
      operate: [],
      viewStatus: 1,
      dataID: 1,

      selectedRow: {},
    }
  },
  async created() {
    this.loading = true
    this.getDatas()
    this.operate = [
      {
        name: '编辑',
        func: 'handleEdit',
        type: 'primary',
      },
      {
        name: '删除',
        func: 'handleDelete',
        type: 'danger',
        auth: '删除合作商',
      }]
    this.loading = false
  },
  methods: {
    onQueryChange(query) {
      // 处理带空格的情况
      this.searchKeyword = query.trim()
      this.getDatas()
    },
    async getDatas() {
      try {
        this.loading = true
        const data = await customApi.gets({ count: this.pageCount, page: this.currentPage, q: this.searchKeyword })
        this.tableData = data.rows
        this.total_nums = data.count
        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.error_code === 10020) {
          this.tableData = []
        }
      }
    },
    handleAdd() {
      this.viewStatus = 2
    },
    handleEdit(val) {
      console.log('val', val)
      this.viewStatus = 3
      this.dataID = val.row.id
    },
    handleDelete(val) {
      this.$confirm('此操作将永久删除该合作商, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await customApi.delect(val.row.id)
        if (res.error_code === 0) {
          await this.getDatas()
          this.$message({
            type: 'success',
            message: `${res.msg}`,
          })
        }
      })
    },
    rowClick() {

    },
    editClose() {
      this.viewStatus = 1
      this.getDatas()
    },

    // 切换table页
    async handleCurrentChange(val) {
      this.currentPage = val
      this.loading = true
      await this.getDatas()
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .header {
    padding: 0 30px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      height: 59px;
      line-height: 59px;
      color: $parent-title-color;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .header-right {
    float: right;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px;
  }
}
</style>
